const ACTION_CLASSES = [
  'ui-action-submit',
  'ui-action-update',
  'ui-action-cancel',
  'ui-action-reset',
  'ui-action-delete',
];

const normalize = (value = '') =>
  value
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

const getButtonLabel = (element) => {
  if (element instanceof HTMLInputElement) {
    return normalize(element.value || element.getAttribute('aria-label') || element.title || '');
  }

  return normalize(
    element.textContent ||
      element.getAttribute('aria-label') ||
      element.title ||
      ''
  );
};

const getActionClass = (label) => {
  if (!label) return null;

  // Destructive actions always win over generic words such as "confirm".
  if (/\b(delete|remove|discard)\b/.test(label)) return 'ui-action-delete';

  // Update/edit forms use a clearly separate blue action.
  if (/\b(update|modify)\b/.test(label) || /^save changes?\b/.test(label)) {
    return 'ui-action-update';
  }

  // Primary create/submit actions use green consistently.
  if (/\b(submit|save|create|add|register)\b/.test(label)) return 'ui-action-submit';

  // Resetting/clearing is intentionally orange so it is not confused with cancel.
  if (/\b(reset|clear)\b/.test(label)) return 'ui-action-reset';

  // Navigation/dismiss actions stay neutral.
  if (/\b(cancel|close|back)\b/.test(label)) return 'ui-action-cancel';

  return null;
};

const shouldSkip = (element) =>
  element.matches('.btn-close') ||
  Boolean(element.closest('.table')) ||
  Boolean(element.closest('.crm-filter-tabs')) ||
  element.hasAttribute('data-no-semantic-style');

const styleButton = (element) => {
  if (!(element instanceof HTMLElement) || shouldSkip(element)) return;

  ACTION_CLASSES.forEach((className) => element.classList.remove(className));

  const actionClass = getActionClass(getButtonLabel(element));
  if (actionClass) element.classList.add(actionClass);
};

const scanButtons = (root = document) => {
  if (root instanceof HTMLElement && root.matches('button, a.btn, input[type="submit"], input[type="button"]')) {
    styleButton(root);
  }

  if (root.querySelectorAll) {
    root
      .querySelectorAll('button, a.btn, input[type="submit"], input[type="button"]')
      .forEach(styleButton);
  }
};

export const initSemanticButtonStyling = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return () => {};

  scanButtons(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        const parent = mutation.target.parentElement;
        if (parent) scanButtons(parent);
        return;
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) scanButtons(node);
      });

      if (mutation.target instanceof HTMLElement) {
        const button = mutation.target.closest('button, a.btn, input[type="submit"], input[type="button"]');
        if (button) styleButton(button);
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  return () => observer.disconnect();
};
